import React, { useEffect } from 'react';
import data from './data/content.json';
import { ContentProvider } from './context/ContentProvider';
import CONFIG from './config';
import Themes from './styles/themes';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import PageContainer from './components/PageContainer/PageContainer';
import { IContent } from './types';
import { fetchAppSetup } from './store/features/app/app';

type AppProps = {
    localeId: string;
};

const App = ({ localeId }: AppProps) => {
    const localizedContent: IContent = data.filter(
        locale => locale.lang === localeId
    )[0];

    useEffect(() => {
        fetchAppSetup();
    }, []);

    return (
        <main id="cloud-unavailable-page">
            <ContentProvider value={localizedContent}>
                <ThemeProvider theme={Themes[CONFIG.isUPC ? 'Uplay' : 'Store']}>
                    <StyleSheetManager
                        target={document.querySelector('#stylesheetsContainer')}
                        disableCSSOMInjection={true}
                    >
                        <PageContainer />
                    </StyleSheetManager>
                </ThemeProvider>
            </ContentProvider>
        </main>
    );
};
export default App;
